<script setup>
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue";
import { pushGAEvent } from "@/analyticsHelper";

import { ref, watch } from "vue";

const isOpen = ref(false);

defineProps({
    currentSite: {
        type: String,
        required: true,
    },
});

watch(isOpen, (newValue) => {
    document.body.style.overflow = newValue ? "hidden" : "";
});
</script>
<template>
    <div class="top-0 sticky z-50">
        <Disclosure
            v-slot="{ open }"
            as="nav"
            class="w-full bg-white text-black shadow-top-animation border-b border-gray"
        >
            <div class="container">
                <div class="mx-auto w-full xl:w-10/12">
                    <div class="flex h-auto items-center p-5 md:px-3 xl:px-0">
                        <div class="flex w-full items-center justify-between">
                            <div class="flex-shrink-0">
                                <slot name="logo" />
                                <div class="hidden relative lg:inline-block text-left">
                                    <div
                                        v-if="currentSite === 'zomerjobs'"
                                        @click="pushGAEvent('preferred-job-location', { job_location: 'NL' })"
                                    >
                                        <a
                                            href="https://animatiewerk.nl/"
                                            title="Werken in Nederland"
                                            target="_blank"
                                            class="flex justify-between items-center space-x-4 py-2 hover:text-orange text-sm"
                                        >
                                            <span>Wil je liever werken in Nederland?</span>
                                            <i class="fa-light fa-arrow-right-long"></i>
                                        </a>
                                    </div>
                                    <div
                                        v-else-if="currentSite === 'animatiewerk'"
                                        @click="pushGAEvent('preferred-job-location', { job_location: 'FR' })"
                                    >
                                        <a
                                            href="https://www.zomerjobs.nl/"
                                            title="Werken in Frankrijk"
                                            target="_blank"
                                            class="flex justify-between items-center space-x-4 py-2 hover:text-orange text-sm"
                                        >
                                            <span>Wil je liever werken in Frankrijk?</span>
                                            <i class="fa-light fa-arrow-right-long"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="hidden lg:ml-6 lg:block">
                                <ul class="flex items-center space-x-2">
                                    <slot name="desktop-menu" />
                                </ul>
                            </div>
                        </div>
                        <div class="-mr-2 flex lg:hidden space-x-3">
                            <slot name="mobile-apply-button" />
                            <DisclosureButton
                                class="inline-flex items-center justify-center p-2 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-orange"
                                @click="isOpen = !isOpen"
                            >
                                <i v-if="!open" class="fa-regular fa-bars text-2xl text-black"></i>
                                <i v-else class="fa-regular fa-xmark text-2xl text-black"></i>
                            </DisclosureButton>
                        </div>
                    </div>
                </div>
            </div>

            <DisclosurePanel class="h-screen lg:hidden">
                <ul>
                    <slot name="mobile-menu" />
                </ul>
            </DisclosurePanel>
        </Disclosure>
    </div>
</template>
